<app-mrp-scrolltop></app-mrp-scrolltop>
<!-- Main -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">

          <div class="right-menu">
            <mat-form-field appearance="fill">
              <mat-label>Tools...</mat-label>
              <mat-select (selectionChange)="onRouteSelect($event.value)" >
                @for (routeOption of delegateroutes; track routeOption) {
                  <mat-option [value]="routeOption.path">
                    {{ routeOption.label }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>

          <h4><b>Precinct Delegate</b></h4>
          <p><strong>Michigan</strong><br></p>
          <p><strong>What Is A Precinct?</strong><br> A precinct is a geographical division that creates a voting unit. It is the smallest political unit in our country.</p>

        </div>

        <div class="col-12-large ">
          <h5 class=""><b>Overview</b></h5>

          <p>Every city and township are divided into precincts. In all municipalities with multiple precincts, the local clerk has a precinct map.
          </p>
          <p>The State of Michigan has <b>4,751</b> precincts, and as of 2023, each precinct cannot exceed <b>4,999</b> registered voters, which are called electors.
        </p>
        <p>Precincts are decided by U.S. Census which takes place every ten years. Population increases and decreases mandate that precinct lines be redrawn as a precinct cannot exceed 4,999 voters.
        </p>
        <p>A precinct has at least one precinct delegate seat. On average there are around 100-200 per county.
        </p>
        <p>The number of delegates allotted to each precinct is determined every two years by the chair of each county political party. This is called a delegate apportionment.
        </p>
        <p>This number is based on the previous vote totals by precinct from the last general November election for President.
        </p>

        <blockquote>
          <p>"Governments are instituted among Men, deriving their just powers from the consent of the governed." - Thomas Jefferson</p>
        </blockquote>

      </div>

    </div>
  </div>
</div>
</section>

<!-- section 2 -->
<section id="main" class="wrapper">
  <div class="inner">
    <div class="content">

      <div class="row">
        <div class="col-12-large">
          <h5 class=""><b>What Is A Precinct Delegate?</b></h5>
          <p>Precinct delegates are liaisons between their community and the county party they represent.
          </p>
          <p>Precinct delegates participate in the <a routerLink="/stateparty"><b>GREAT PROCESS</b></a> of governing the Republican Party.
        </p>
        <p>Every registered voter within their precinct qualifies to be elected as a precinct delegate.
        </p>

        <h5 class=""><b>What Are The Duties of a Precinct Delegate?</b></h5>
        <p>Precinct delegates participate in their county conventions, state party conventions and their local county meetings.
        </p>
        <p>They are responsible for organizing party events at a local level such as:
        </p>
        <b>
          <ol>
            <li>Monthly meetings</li>
            <li>Rallies</li>
            <li>Fundraising</li>
            <li>Awareness and Outreach</li>
            <li>Political support for local needs</li>
            <li>Liazon to town meetings</li>
            <li>Serving on district party committees</li>
            <li>Serving on state party committees</li>
          </ol>
        </b>

        <p>The <i>effectiveness</i> of any county is directly based on the participation level of it's delegates and the work they do.
      </p>


    </div>

    <div class="col-12-large ">
      <h5 class=""><b>Become A Precinct Delegate</b></h5>
      <p>There are two paths to becoming a precinct delegate. The first is to be elected. The second is to be elevated at convention.
      </p>
      <h5><b>Path One: Election</b></h5>
      <p>Precinct delegates are elected every two years at the August county election and serve a two year term.
        County clerks are required to keep records of all elected precinct delegates, and there are no term limits for being a delegate.
      </p>
    </div>

    <div class="col-12-small ">
      <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
        <div class="col">
          <div class="card h-100">
            <img class="steps card-img-top img-fluid"
              src="assets/images/precinct/stepONE.png" alt="Step One">
              <div class="card-body">
                <!-- <h4 class="card-title">Step One</h4> -->
                <p class="card-text">Determine the precinct you live in. This will be on your voter registration card.
                  <br> <b>OR </b><br>
                  Ask your county clerk
                  <br> <b>OR </b><br>
                  You can find it online at the Secretary of State web site.
                </p>
                <a href="https://mvic.sos.state.mi.us/Voter/Index"><button class="btn ">Find</button></a>
              </div>
            </div>
          </div>
          <div class="col">
            <div class="card h-100">
              <img class="steps card-img-top img-fluid"
                src="assets/images/precinct/stepTWO.png" alt="Step Two">
                <div class="card-body">
                  <!-- <h4 class="card-title">Step Two</h4> -->
                  <ol>
                    <li>Fill in and submit Affidavit of Identity. However, do not sign it. The affidavit must
                    be signed in the presence of a notary.</li>
                    <li>Most county clerks are also a notary, and may perform this service for you.</li>
                    <li>File the original copy with your county clerk via mail or in-person.</li>
                  </ol>
                  <p>
                    <br>
                      <br>
                        <u>Filing Deadline</u>
                        <br>
                          <br>
                            <b>Tuesday, May 7, 2024</b>
                          </p>
                          <a href="https://www.michigan.gov/sos/-/media/Project/Websites/sos/25delrio/Aff-ID_Precnt_139901_7.pdf"><button class="btn ">Affidavit</button></a>
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="card h-100">
                        <img class="steps card-img-top img-fluid"
                          src="assets/images/precinct/stepTHREE.png" alt="Step Three">
                          <div class="card-body">
                            <!-- <h4 class="card-title">Step Three</h4> -->
                            <ol>
                              <li>Establish name recognition for yourself</li>
                              <li>Distribute your campaign literature in your precinct</li>
                            </ol>
                            <p>
                              <br>
                                <br>
                                  <u>Next Primary Election</u>
                                  <br>
                                    <br>
                                      <b>Tuesday, August 6, 2024</b>
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>




                        </div>
                      </div>
                    </div>
                  </section>


                  <!-- section 3 -->
                  <section id="main" class="wrapper">
                    <div class="inner">
                      <div class="content">

                        <div class="row">
                          <div class="col-12-large">


                            <h5 class=""><b>"Write-In Candidates"</b></h5>

                            <p>
                              <i>If you miss the deadline of <b>Tuesday, May 7, 2024</b> for filing the Affidavit of Identity, there is still an opportunity to enter the primary election as a "Write-In candidate".</i>
                              Ask your county clerk for the current list of precinct delegate candidates.
                              If not enough people have filed for election for precinct delegate, then you can be a "Write-In" on election day.


                              You must complete the Write-In Declaration of Intent and submit it to your county clerk.
                              Do not sign the form. It must be signed in the presence of a notary.
                              File the original with the county clerk by 4pm on the Friday prior to election day.
                            </p>
                            <p>
                              That date is <b>Friday, August 2, 2024</b>
                            </p>
                            <p>
                              You will also need to ask your neighbors to fill in the oval next to one of the blank spaces for precinct delegate on their ballot
                              and write in your name.
                              <b>
                              It must be spelled exactly as written on your Declaration of Intent.</b>
                            </p>

                          </div>

                          <div class="col-12-large ">

                            <h5 class=""><b>Path Two: Elevation</b></h5>
                            <p>
                              At county conventions, existing delegates may vote to elevate precinct delegates to fill any vacant seats that exist in the county.
                              The intention is that more is better, and there should be no vacancies.
                              <p>
                                It takes a majority vote of the delegates gathered at convention to approve your elevation to be a precinct delegate.
                              </p>

                              <p>
                                Vacancies mean lack of representation.
                              </p>

                            </div>

                          </div>
                        </div>
                      </div>
                    </section>


                    <!-- section 4 -->
                    <section id="main" class="wrapper">
                      <div class="inner">
                        <div class="content">

                          <div class="row">
                            <div class="col-12-large">

                              <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                                <div class="col">
                                  <div class="card h-100">
                                    <img class="steps card-img-top img-fluid"
                                      src="assets/images/precinct/stepONEburgundy.png" alt="Step One">
                                      <div class="card-body">
                                        <!-- <h4 class="card-title">Step One</h4> -->
                                        <ol>
                                          <li>Visit with existing executive committee members and explain why you want to be elevated and gain their support.</li>
                                        </ol>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="col">
                                    <div class="card h-100">
                                      <img class="steps card-img-top img-fluid"
                                        src="assets/images/precinct/stepTWOgold.png" alt="Step Two">
                                        <div class="card-body">
                                          <!-- <h4 class="card-title">Step Two</h4>                            -->
                                          <ol>
                                            <li>Persuade others you need their vote</li>
                                            <li>Create an outline of your intentions to serve the party</li>
                                            <li>Ask a current delegate to nomitate you</li>
                                          </ol>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col">
                                      <div class="card h-100">
                                        <img class="steps card-img-top img-fluid"
                                          src="assets/images/precinct/stepTHREEnavy.png" alt="Step Three">
                                          <div class="card-body">
                                            <!-- <h4 class="card-title">Step Three</h4> -->
                                            <ol>
                                              <li> Show up at convention</li>
                                              <li>Have a short prepared speech for your fellow delegates about why you should be elected</li>
                                            </ol>
                                          </div>
                                        </div>
                                      </div>
                                    </div>


                                  </div>

                                  <div class="col-12-large ">

                                    <h5 class=""><b>Moving</b></h5>
                                    <p>If a precinct delegate moves they no longer represent that precinct.
                                      Therefore, upon moving, they are no longer a delegate in that precinct and a vacancy will exist.
                                      A person will have to be elected or elevated in their new precinct in order to be a delegate again.
                                    </p>

                                  </div>

                                </div>
                              </div>
                            </div>
                          </section>

                          <!-- section 5 -->
                          <section id="main" class="wrapper">
                            <div class="inner">
                              <div class="content">

                                <div class="row">
                                  <div class="col-12-large">

                                    <h5 class=""><b>Official Responsibilities</b></h5>

                                    <p>The primary official duties of a precinct delegate are to attend four county conventions during the two year term.
                                    </p>
                                    <ol>
                                      <li>Attend</li>
                                      <li>Participate</li>
                                      <li>Vote</li>
                                    </ol>


                                    <p><b>In Addition</b></p>
                                    <p>Precinct delegates may be elected to attend up to three state conventions and one national convention during their term.
                                    </p>
                                    <p>They may choose to serve on a party committee or be elected to leadership.
                                    </p>

                                    <a href="/countyconvention"><h6>County Conventions</h6></a>

                                    <p>Elect county party leadership
                                    </p>
                                    <p>Elect state delegates to attend state conventions
                                    </p>

                                    <a href="/stateconvention"><h6>State Conventions</h6></a>

                                    <p>Elect state party leadership
                                    </p>
                                    <p>Nominate Republican Party candidates
                                    </p>
                                    <ol>
                                      <li>Governor, Lieutenant Governor</li>
                                      <li> Attorney General, Secretary of State </li>
                                      <li>Michigan Supreme Court</li>
                                      <li>Board of Education</li>
                                      <li>University Boards</li>
                                      <li>Presidential Electors</li>
                                    </ol>


                                  </div>

                                  <div class="col-12-large ">

                                    <h5 class=""><b>Delegate Influence</b></h5>
                                    <p>Become influencial by creating awareness in your precinct <br>
                                      Promote party candidates to ensure a continued majority and representation <br>
                                      Encourage voting, lobbying, attending commission meetings
                                    </p>

                                    <h5 class=""><b>Party Influence</b></h5>
                                    <p>Inform party leadership of important voter issues and concerns <br>
                                      Represent the precinct at party meetings and other political events <br>
                                    </p>

                                  </div>

                                </div>
                              </div>
                            </div>
                          </section>

                          <!-----------------END OG PAGE -------------------------------------------------->
























